import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import useHasMounted from '../../hooks/useHasMounted';
import { IChildrenProps } from '../../models/utilTypes';

const createRoot = (portalId: string, isTopLevel: boolean) => {
  const nextRoot = document.getElementById('__next');
  let portalRoot = document.getElementById(portalId);
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.id = portalId;
  }
  if (isTopLevel) {
    nextRoot?.appendChild(portalRoot);
  }
  return portalRoot;
};

export interface IPortalProps extends IChildrenProps {
  portalId: string;
  element?: HTMLElement;
  isTopLevel?: boolean;
}

const Portal: React.FC<IPortalProps> = ({
  children,
  element,
  portalId,
  isTopLevel = true
}) => {
  const hasMounted = useHasMounted();
  const [root, setRoot] = useState(element);

  useEffect(() => {
    if (!root) setRoot(createRoot(portalId, isTopLevel));
  }, [root, portalId, isTopLevel]);

  if (!hasMounted || !root || !children) return null;

  return ReactDOM.createPortal(children, root);
};

export default Portal;
